<template>
  <div>
    

    <div class="route-bar" style="padding-bottom: 10px;">
      <div v-if="showBreadcrumbs" class="route-bar-breadcrumb" style="padding-top: 10px; padding-bottom: 0px;">
        <ul>
          <li>
            <button class="p-link" @click="home">
              <i class="pi pi-home"></i>
            </button>
          </li>
          <li v-if="$route.path === '/'">/</li>
          <template v-for="(crumb, i) of breadcrumbs">
            <li
              v-if="crumb.to"
              :key="i"
              @click="goToCrumb(crumb)"
              class="anchorTag"
              :title="crumb.title"
            >/ {{ crumb.label }}</li>
            <li v-else :key="i" :title="crumb.title">/ {{ crumb.label }}</li>
          </template>
        </ul>
      </div>
      <!-- <div class="route-bar-buttons">
        <Button @click="openNewOpportunity()" label="New Enquiry" class="p-button-raised p-button-rounded p-button-sm p-px-2 p-ml-1" />
        <Button @click="openNewContact()" label="New Contact" class="p-button-raised p-button-rounded p-button-sm p-px-2 p-ml-1" />
        <Button @click="openNewActivity()" label="New Activity" class="p-button-raised p-button-rounded p-button-sm p-px-2 p-ml-1" />
        <Button @click="openNewNote()" label="New Note" class="p-button-raised p-button-rounded p-button-sm p-px-2 p-ml-1" />
      </div> -->
    </div>

    <div class="container" style="padding-top:10px;" v-if="messages && messages.length">
      <div class="errorMsg">
        <span class="errorSpan pr-5">Some data was not loaded from different EPs.</span>
        <span class="errorSpan errorPointer pr-3" @click="viewAllErrors = true">View errors</span>
        <span class="errorSpan errorPointer" @click="clearAllErrors()">Clear messages</span>
      </div>
      <!-- <Message 
        v-for="(msg, index) of messages" 
        :key="index"
        :severity="msg.severity" 
        :life="msg.life"
        :closable="true"
      >{{msg.content}}</Message> -->
    </div>

    <ErrorsMessageDialog
      :viewDialog="viewAllErrors"
      :messages="messages"
      @close="viewAllErrors = false"
      @clearAllErrors="viewAllErrors = false; clearAllErrors()"
    />

    <Dialog v-if="enquirySuccess" header="Success" :visible.sync="enquirySuccess" :style="{width: '500px'}" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-info-circle p-mr-3" style="font-size: 2rem" />
        <span>A new enquiry was saved successfully. The sQuote No is {{enquirySQuoteNo}}</span>
      </div>
      <template #footer>
        <Button label="Ok" icon="pi pi-check" @click="enquirySuccess = false" class="p-button-text" autofocus />
        <Button
          @click="enquirySuccess = false; newQuote(enquiry)"
          label="Book In"
        />
      </template>
    </Dialog>

    <!-- Dialog to Create & Edit an enquiry -->
    <OpportunityForm
      :key="enquiryFormKey"
      v-if="enquiryDialog"
      :onlyUserBranch="onlyUserBranch"
      :opportunityDialog="enquiryDialog"
      :opportunityToEdit='enquiryToEdit'
      :disabledArray="enquiryDisabledArray"
      :colSelectedFieldsForTable="enquiryColsSelectedFieldsForTable"
      @close="enquiryDialog = false"
      @save="savedOpportunity"
    />

    <deplicateTable
      v-if="enquiryColsSelectedFieldsForTable"
      :duplicateDialog="enquiryDuplicateMessage"
      :colSelectedFieldsForTable="enquiryColsSelectedFieldsForTable"
      :dataId="'oppId'"
      :name="'Enquiry'"
      :namePlural="'Enquiries'"
      :list="enquiryDuplicates"
      :requesting="duplicateRequesting"
      @close="enquiryDuplicateMessage = false"
      @agree="enquirySendDuplicate()"
    />

    <ContactForm
      :reload="reloadContactForm"
      :contactToEdit="contactToEdit"
      :contactForm="contactFormDialog"
      :disabledArr="contactDisabledArr"
      @hide-form-dialog="contactFormDialog = false"
      @submit-contact-form="savedContact"
    />

    <DuplicateDialog
      v-if="contactDuplicateDialog"
      :key="contactDuplicateDialogKey"
      :duplicateDialog="contactDuplicateDialog"
      :contact="contactDuplicateContact"
      @hide-duplicate-dialog="contactDuplicateDialog = false"
      @submit-duplicate-form="contactSaveDuplicate"
    />

    <ActivityForm
      v-if="activityDialog"
      :key="activityFormKey"
      :activityForm="activityDialog"
      mode="auto"
      :activityToEdit="activity"
      :disabledArr="[]"
      @close="activityDialog = false"
      @saved="savedActivity"
    />

    <NoteForm
      v-if="noteDialog"
      :reload="reloadNoteForm"
      :noteDialog="noteDialog"
      :noteToEdit="note"
      :disabledArray="[]"
      @close="noteDialog = false"
      @noteSaved="noteSaved"
    />

    <QuotationForm
      :quotationDialog="quotationDialog"
      :opportunity="opportunity"
      :active="activeQuote"
      :quoteToEdit="quotation"
      :disabledArr="disabledArray"
      @close="quotationDialog = false"
      @saved="saved"
    />
  </div>
</template>

<script>
import CustomerService from "@/service/CustomerService";
import OpportunityService from "@/service/OpportunityService";
import FiltersService from "@/service/FiltersSerice";

import OpportunityForm from './mbp/universalComponents/opportunity/OpportunityForm'
import deplicateTable from './mbp/universalComponents/opportunity/duplicateDialog'
import ContactForm from './mbp/universalComponents/contact/contactForm'
import DuplicateDialog from './mbp/universalComponents/contact/duplicateDialog'
import ActivityForm from "./mbp/universalComponents/activity/ActivityForm.vue";
import NoteForm from './mbp/universalComponents/note/NoteForm'
import QuotationForm from "@/mbp/universalComponents/quotation/QuotationForm.vue";
import ErrorsMessageDialog from './mbp/universalComponents/ErrorsMessageDialog'

import { LIST_ROUTES, TRAIL_LENGTH, listCrumbLabel, savedFilterName, trailNodeFor } from './listViewRegistry.js'
import navTrail, { syncBreadcrumb } from './navTrail.js'
import EventBus from './event-bus'

export default {
  components: {
    OpportunityForm,
    deplicateTable,
    ContactForm,
    DuplicateDialog,
    ActivityForm,
    NoteForm,
    QuotationForm,
    ErrorsMessageDialog
  },
  data: () => ({
    filtersService: new FiltersService(),
    opportunityService: new OpportunityService(),
    customerService: new CustomerService(),
    enquiryDisabledArray: [],
    enquiryFormKey1: 0,
    enquiryDialog: false,
    enquiryToEdit: {},
    enquirySQuoteNo: '',
    enquiry: {},
    enquirySuccess: false,
    enquiryDuplicateMessage: false,
    enquirySelectedCustomer: {},
    enquiryDuplicates: [],
    enquiryColsSelectedFields: [],
    enquiryColsSelectedFieldsForTable: [],
    enquiryDBViewFields: [],
    enquiryDBViewId: 8,
    reloadContactForm: 0,
    contactToEdit: {},
    contactFormDialog: false,
    contactDuplicateDialog: false,
    contactDuplicateContact: {},
    contactDuplicateToSend: {},
    contactDisabledArr: [],
    contactDuplicateDialogKey1: 0,
    activity: {},
    activityDialog: false,
    activityFormKey1: 0,
    note: {},
    submitted: false,
    noteDialog: false,
    reloadNoteForm: 0, // this is not the key
    disabledArray: [],
    quotation: {},
    activeQuote: false,
    opportunity: {},
    quotationDialog: false,
    viewAllErrors: false,
    duplicateRequesting: false,
    onlyUserBranch: false
  }),
  computed: {
    myPermissions() {
      return this.$store.getters['auth/getUserPermissions']
    },
    showBreadcrumbs() {
      return this.$route.path !== '/'
    },
    breadcrumbRecordName() {
      return this.$store.getters['getBreadcrumbRecord']
    },
    breadcrumbRecordType() {
      return this.$store.getters['getBreadcrumbRecordType']
    },
    // The crumb the list on screen should have, as one string so the watcher below fires only
    // when the text changes. Null off a list page.
    currentListCrumb() {
      const node = trailNodeFor(this.$route)
      if (!node || node.kind !== 'list') return null
      const crumb = this.listCrumb(node.listRoute, node.label)
      return [node.key, crumb.label, crumb.title || ''].join('\n')
    },
    // Built from the route registry rather than by splitting the URL. The old
    // renderer emitted raw path segments, so a customer page read
    // "/ customers / 42 / detail" and a crumb click pushed a bare path - which
    // dropped the query the list's search text lives in.
    breadcrumbs() {
      const route = this.$route
      const trail = this.$store.getters['getBreadcrumbTrail'] || []

      if (trail.length) {
        // Only the last few, so a deep drill-down stays readable. The final
        // crumb is where you already are, so it isn't a link.
        const shown = trail.slice(-TRAIL_LENGTH)
        return shown.map((node, i) => ({
          label: node.label,
          title: node.title,
          to: i === shown.length - 1 ? null : node.fullPath,
          fullPath: node.fullPath
        }))
      }

      // Settings, reports and the other one-off pages are not in the registry,
      // so they never enter the trail. They carry no record ids, so readable
      // path segments are still fine.
      return route.path
        .split('/')
        .filter(Boolean)
        .map(segment => ({ label: this.humanise(segment), to: null }))
    },
    messages() {
      
      return this.$store.getters.getErrorMessages
    },
    activityFormKey: {
      set(val) {
        this.activityFormKey1++
      },
      get() {
        return 'activityForm' + this.activityFormKey1.toString()
      }
    },
    contactDuplicateDialogKey: {
      set() {
        this.contactDuplicateDialogKey1++
      },
      get() {
        return 'contactDuplicateDialogKey-' + this.contactDuplicateDialogKey1.toString()
      }
    },
    enquiryFormKey: {
      set(val) {
        this.enquiryFormKey1++
      },
      get() {
        return 'enquiryFormKey' + this.enquiryFormKey1.toString()
      }
    }
  },
  mounted() {
    

    this.enquiryGetColumnSelection()
    this.enquiryGetDBViewFields()

  },
  created() {
    // App.vue announces every left-menu click - the one thing that resets the trail.
    EventBus.$on('menu-navigation', this.onMenuNavigation)
  },
  beforeDestroy() {
    EventBus.$off('menu-navigation', this.onMenuNavigation)
  },
  watch: {
    // Update the trail on every navigation, including the first.
    $route: {
      immediate: true,
      handler() {
        this.syncTrail(true)
      }
    },
    // The record's name arrives after the detail page has fetched it, so the
    // crumb starts as "Customer" and fills in to "Customer: ALBOIN BUILDERS".
    breadcrumbRecordName() {
      this.syncTrail(false)
    },
    // A task's page names its kind once the record has loaded: "Activity" becomes "Task".
    breadcrumbRecordType() {
      this.syncTrail(false)
    },
    // A saved filter picked (or a default one applied) while the list stays open changes no
    // route, so relabel the list's crumb here - and restamp the entry, so the record opened
    // next, and a Back to either, carry the name. A change of route is the $route watcher's job.
    currentListCrumb(now, before) {
      if (!now || !before) return
      if (now.split('\n')[0] !== before.split('\n')[0]) return
      this.syncTrail(false)
    },
    quotationDialog(val) {
      // 
      if (val && this.opportunity && this.opportunity.customer && this.opportunity.customer.requireApproval === true) {
        this.quotationDialog = false

        this.$toast.add({
          severity: "warn",
          summary: "Not allowed",
          detail: "Customer must be approved before Booking In the quotation",
          life: 5000,
        })
      }
    },
    contactDuplicateDialog(val) {
      this.contactDuplicateDialogKey = this.contactDuplicateDialogKey1 + 1
    },
    contactFormDialog(val) {
      this.reloadContactForm++
    },
    enquiryColsSelectedFieldsForTable(val) {
      
    },
    enquiryDialog(val) {
      if (val) {
        this.enquiryFormKey = this.enquiryFormKey1 + 1
      }
    },
    enquiryDBViewFields(val) { // toggles between default view and user saved view
      
      if (this.enquiryColsSelectedFieldsForTable.length < 1) {
        this.enquiryColsSelectedFieldsForTable = val.filter(a => a.defView)
      }
      // this.enquiryColsSelectedFieldsForTable.forEach(a => 
    }
  },
  methods: {
    saved({ quote, file, params, active }) {
      
      this.activeQuote = false
      this.quotationDialog = false
      this.quotation = {};
    },
    newQuote(opportunity) {
      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'AddNewQuotation');
      if (permission) {
          if (permission.permissionLevel === 0) {
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You are not allowed to create a new Quotation",
            life: 5000,
          })
        } 
        else if (permission.permissionLevel === 1 || permission.permissionLevel === 4 || permission.permissionLevel === 5) {
          this.opportunity = opportunity
          this.disabledArray = [
            'opportunity',
            'mbpBranch',
            'Customer'
          ]
          // this.quotation = { ...this.opportunity, opportunity: this.opportunity };
          this.activeQuote = true
          this.quotationDialog = true;
        } 
      }
    },
    home() {
      // Was window.location = "/#/", which is a hash URL the history-mode
      // router never matches: it forced a full page reload and, on the way,
      // reset the firstTimeLoad flag every list uses to decide whether to
      // restore its filters. Routing in-app keeps that state intact.
      if (this.$route.path !== "/") {
        this.$router.push("/").catch(() => {});
      }
    },
    noteSaved() {
      this.noteDialog = false;
      this.note = {};
    },
    openNewNote() {
      this.note = {};
      this.noteDialog = true;
      this.reloadNoteForm++
    },
    savedActivity(activity) {
      
      this.activityDialog = false
    },
    openNewActivity() {
      this.activity = {}
      this.activityDialog = true;
    },
    contactSaveDuplicate() {
      this.contactDuplicateDialog = false

      this.customerService
        .saveDuplicateContactDB(this.contactDuplicateToSend)
        .then(response => {
          
          if (response.status === 200) {
            this.$toast.add({
              severity: "success",
              summary: "New Contact Saved",
              detail: `New contact was saved successfully`,
              life: 5000,
            });
          }
        })
        .catch(err => {
          
                
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while saving customer",
            life: 5000,
          })
        })
    },
    savedContact({ contact, duplicateContact, duplicateToSend }) {
      this.contactToEdit = {}
      this.contactFormDialog = false
      if (duplicateToSend) {
        this.contactDuplicateToSend = duplicateToSend
        this.contactDuplicateContact = duplicateContact
        this.contactDuplicateDialog = true
      }
    },
    openNewContact() {
      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'AddNewContact');
      if (permission) {
          if (permission.permissionLevel === 0) {
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You are not allowed to create a new contact",
            life: 5000,
          })
        } else if (permission.permissionLevel === 1) {
          this.contactToEdit = { country: 'UK' }
          this.contactToEdit.canEmail = true;
          this.contactToEdit.canCall = true;
          this.contactToEdit.canMail = true;
          this.contactToEdit.active = true;
          this.contactDisabledArr = ['country']
          this.contactFormDialog = true
        }
      }
    },
    enquiryGetDBViewFields() {
      this.filtersService
        .getDBViewFields(this.enquiryDBViewId)
        .then(data => {
          this.enquiryDBViewFields = data
        })
        .catch(err => {
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customer DB view fields",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "dbViewFields/{dbView}"'
          })
        })
    },
    enquiryGetColumnSelection() {
      this.filtersService
        .getColumnSelection(this.enquiryDBViewId)
        .then(data => {
          
          this.enquiryColsSelectedFields = data
          
          let a = []
          data.forEach(b => {
            // 
            let c = a.find(d => d.dbField === b.dbField.dbField)
            // 
            if (!a[b.colOrder - 1] && !c) {
              a[b.colOrder - 1] = { 
                ...b.dbField,
                defWidth: b.width
              }
            }
          })
          
          if (a.length) {
            this.enquiryColsSelectedFieldsForTable = a
          }
        })
        .catch(err => {
          

          if (err.response.status === 500) {
            // Default view
            
          }
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while column selection",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "currentUserViewFields/{dbView}"'
          })
        })
    },
    enquirySendDuplicate() {
      this.duplicateRequesting = true
      this.enquiry.custCode = this.enquirySelectedCustomer.custCode

      this.opportunityService
        .saveDuplicateOpportunity(this.enquiry)
        .then((response) => {
          this.duplicateRequesting = false
          this.enquiryDuplicateMessage = false
          
          this.enquiry = response.data;
          
          this.enquirySQuoteNo = this.enquiry.sQuoteNo
          this.enquirySuccess = true
          
          if (response.status === 200) {
            this.$toast.add({
              severity: "success",
              summary: "New Enquiry Saved",
              detail: `new Enquiry was saved successfully, Quote No generated : ${this.enquiry.sQuoteNo}`,
              life: 5000,
            });
            this.enquiryDialog = false;
          }
        })
        .catch((e) => {
          this.duplicateRequesting = false
          this.enquiryDuplicateMessage = false
          

          if (e.response)                
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving enquiry",
              life: 5000,
            })
        })
    },
    savedOpportunity(e) {
      
      this.enquiry = e.opportunity
      this.enquirySelectedCustomer = e.customer
      if (e.duplicates && e.duplicates.length) {
        this.enquiryDuplicates = e.duplicates;
        this.enquiryDuplicateMessage = true
      } else {
        if (e.sQuoteNo) {
          this.enquirySQuoteNo = e.sQuoteNo
          this.enquirySuccess = true
        }
      }
    },
    openNewOpportunity() {
      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'AddNewEnquiry');
      if (permission) {
          if (permission.permissionLevel === 0) {
          this.onlyUserBranch = false
          this.$toast.add({
            severity: "error",
            summary: "Not allowed",
            detail: "You are not allowed to create a new record",
            life: 5000,
          })
        } 
        else if (permission.permissionLevel === 1 || permission.permissionLevel === 4) {
          this.onlyUserBranch = false
          this.enquiryToEdit = { 'country': 'UK' }
          this.enquiry = {};
          this.enquiryDisabledArray = ['Country']
          this.enquiryDialog = true;
        } 
        else if (permission.permissionLevel === 5) {
          this.onlyUserBranch = true
          this.enquiryToEdit = { 'country': 'UK' }
          this.enquiry = {};
          this.enquiryDisabledArray = ['Country']
          this.enquiryDialog = true;
        }
      }
    },
    clearAllErrors() {
      this.$store.dispatch('setErrorMessage', [])
    },
    // Keeps the trail in step with where the user actually is (navTrail.js, item 2, 2026-09-27):
    //
    //   a left-menu click         -> start again from this page
    //   Back / Forward            -> the trail stamped on that history entry, untouched
    //   already in the trail      -> cut back to it (a tab of the same record, a crumb click)
    //   anything else registered  -> append (drilling one level deeper)
    //
    // Anything outside the registry is left alone, so a detour through Settings doesn't wipe the
    // drill-down you were in - unless the menu took you there. The result is stamped into the
    // current history entry so Back and Forward can put it back.
    syncTrail(routeChanged, menu = false) {
      const next = syncBreadcrumb({
        nav: navTrail,
        route: this.$route,
        trail: this.$store.getters['getBreadcrumbTrail'] || [],
        labelFor: node => this.trailLabel(node),
        routeChanged: !!routeChanged,
        menu,
        history: window.history
      })
      if (next) this.$store.dispatch('setBreadcrumbTrail', next)
    },
    // A left-menu item was clicked. On the page already open nothing navigates, so reset now;
    // otherwise the reset happens when the navigation arrives.
    onMenuNavigation(to) {
      if (!to) return
      const target = this.$router.resolve(to).route
      if (target.fullPath === this.$route.fullPath) {
        this.syncTrail(false, true)
      } else {
        navTrail.markMenuNavigation(target.path)
      }
    },
    trailLabel(node) {
      if (node.kind === 'list') {
        // Say so when the list is showing a subset, since that is exactly what
        // clicking this crumb will take you back to - by name for a saved filter.
        return this.listCrumb(node.listRoute, node.label)
      }
      const record = this.$store.getters['getBreadcrumbRecord']
      const type = this.$store.getters['getBreadcrumbRecordType'] || node.typeLabel
      return record ? `${type}: ${record}` : type
    },
    listCrumb(listRoute, label) {
      const entry = LIST_ROUTES[listRoute]
      if (!entry) return { label }
      return listCrumbLabel(label, {
        savedFilterName: savedFilterName(this.$store.getters[`${entry.storeModule}/getMainListSavedFilter`]),
        filtered: this.listIsFiltered(listRoute)
      })
    },
    listIsFiltered(listRoute) {
      const entry = LIST_ROUTES[listRoute]
      if (!entry) return false
      const g = n => this.$store.getters[`${entry.storeModule}/${n}`]
      const saved = g('getMainListSavedFilter')
      const quick = g('getMainListQuickFilter') || []
      return !!(
        (saved && saved.id) ||
        g('getSearchText') ||
        quick.some(v => v !== null && v !== undefined)
      )
    },
    // Each crumb carries the exact path it was recorded at, query included, so
    // going back to a filtered list lands on that filtered list. The list's
    // sort, page and scroll come back from its own Vuex module, the same way
    // the Back button gets them.
    goToCrumb(crumb) {
      if (!crumb.to) return
      this.$router.push({ path: crumb.to }).catch(() => {})
    },
    humanise(segment) {
      // W7 tail. $route.path is the encoded path - vue-router percent-encodes a param when
      // it fills it - so a report named "Rows behind this widget" arrives here as
      // "Rows%20behind%20this%20widget". A segment that is not valid percent-encoding (a
      // bare '%') makes decodeURIComponent throw, and one odd segment must not take the
      // whole breadcrumb bar down with it.
      let decoded = segment
      try {
        decoded = decodeURIComponent(segment)
      } catch (e) {
        decoded = segment
      }
      const spaced = decoded.replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      return spaced.charAt(0).toUpperCase() + spaced.slice(1)
    }
  }
};
</script>

<style lang="scss">

.errorMsg {
  width: 100%;
  height: 30px;
  background-color: orangered;
  opacity: 60%;
  border-radius: 5px;
  text-align: center;
  color: white;
  
  @media (max-width: 430px) {
    margin-top: 55px;
  }
}

.errorSpan {
  line-height: 28px;
}

.errorPointer {
  cursor: pointer;
}

.errorPointer:hover {
  cursor: pointer;
  text-decoration: underline;
}

.route-bar-buttons {
  float:right; 
  padding-top: 5px; 
  padding-right: 5px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

</style>